module.exports = __webpack_public_path__ + "static/media/sf-t1.c6a76952.svg";